export const formatTime = (time: string) => {
  var date = new Date("1970-01-01 " + time);
  var hours = date.getHours();
  var minutes = date.getMinutes().toString();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return hours + ':' + minutes.padStart(2, '0') + ' ' + ampm;
}